export default __webpack_public_path__ + "static/media/RGA.2d5982e5.jpg";